@if (mapItem(); as mapItem) {
    <ui-detail-view-container>
        <ui-detail-section>
            <ui-detail-image
                [imagePath]="mapItem.imagePath"
                [altText]="mapItem.title"
            />

            <ui-detail-title [title]="mapItem.title"/>

            <ui-detail-address [text]="mapItem.address"/>

            @if (mapItem.addressAddition) {
                <ui-detail-description
                    [title]="'Addresszusatz'"
                    [htmlDescription]="mapItem.addressAddition"
                />
            }

            @if (newFounding) {
                <ui-detail-tags
                    [tags]="newFoundingTags"
                />
                <ui-detail-description
                    [htmlDescription]="newFounding.ideaDescription"
                />
                <ui-detail-tags
                    [tags]="newFounding.foundingCategories"
                />
            } @else {
                <ui-detail-tags
                    [tags]="mapItem.tags"
                />
            }

        </ui-detail-section>

        @if (mapItem.targetGroups) {
            <ui-detail-tags
                [title]="'Zielgruppen'"
                [tags]="mapItem.targetGroups"
            />
        }

        @if (mapItem.description; as description) {
            <ui-detail-description
                [title]="'Beschreibung'"
                [htmlDescription]="description"
            />
        }

        <ui-detail-section [title]="'Kontakt'">
            @if (mapItem.email; as email) {
                <ui-detail-email-link
                    [title]="'E-Mail'"
                    [email]="email"
                />
            }

            @if (mapItem.website; as weblink) {
                <ui-detail-weblink
                    [title]="'Website'"
                    [link]="weblink"
                />
            }
        </ui-detail-section>

        @if (mapItem.contact; as contact) {
            <ui-detail-contact
                [title]="'Ansprechperson'"
                [contact]="contact"
            />
        }
    </ui-detail-view-container>
}
